import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/logo-horizontal.png'
import _imports_1 from '@/assets/img/x-circle.svg'
import _imports_2 from '@/assets/img/menu.svg'


const _withScopeId = n => (_pushScopeId("data-v-4b8eb5d9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main-grid" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "logo" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "logo"
  })
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "close__icon",
  src: _imports_1,
  alt: "close"
}, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "main-grid__navbar" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "ham-button__icon",
  src: _imports_2,
  alt: "menu"
}, null, -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "logo-content__img",
  src: _imports_0,
  alt: "logo"
}, null, -1))
const _hoisted_9 = { class: "content" }
const _hoisted_10 = { class: "aside" }
const _hoisted_11 = { class: "message-section" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Sidebar = _resolveComponent("Sidebar")!
  const _component_MainView = _resolveComponent("MainView")!
  const _component_FinancialTips = _resolveComponent("FinancialTips")!
  const _component_ClosedObligations = _resolveComponent("ClosedObligations")!
  const _component_FinancialTipsCarousel = _resolveComponent("FinancialTipsCarousel")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", {
      class: _normalizeClass(["main-grid__side", { active: _ctx.isActive }])
    }, [
      _createElementVNode("button", {
        class: "main-grid__side-close",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isActive = !_ctx.isActive))
      }, _hoisted_4),
      _createVNode(_component_Sidebar, {
        "user-data": _ctx.authUser,
        onCloseSidebar: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isActive = false))
      }, null, 8, ["user-data"])
    ], 2),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("button", {
        class: "ham-button",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.isActive = !_ctx.isActive))
      }, _hoisted_7),
      _hoisted_8
    ]),
    _createElementVNode("section", _hoisted_9, [
      (!_ctx.showFinancialTips)
        ? (_openBlock(), _createBlock(_component_MainView, {
            key: 0,
            "is-loading-obligations": _ctx.isLoadingObligations,
            "is-loading-payment-status": _ctx.isLoadingPaymentStatus,
            onFetchDataGenaral: _ctx.fetchDataGenaral
          }, null, 8, ["is-loading-obligations", "is-loading-payment-status", "onFetchDataGenaral"]))
        : (_openBlock(), _createBlock(_component_FinancialTips, { key: 1 }))
    ]),
    _createElementVNode("section", _hoisted_10, [
      _createVNode(_component_ClosedObligations, { "is-loading": _ctx.isLoadingObligations }, null, 8, ["is-loading"])
    ]),
    _createElementVNode("section", _hoisted_11, [
      _createVNode(_component_FinancialTipsCarousel)
    ])
  ]))
}